<ycn-modal-base
        [open]="modalOpen"
        (closeModalHandler)="this.closeModal()">
    <ycn-simple-modal-header
            [header]="'Select Info Field'"
            [resetModalText]="'Reset'"
            (closeModalHandler)="this.closeModal()"
            (resetModalHandler)="resetModal()">
    </ycn-simple-modal-header>
    <div class="modal-body">
        <ycn-info-field-list
                [infoType]="infoType"
                [isSingleSelect]="true"
                [modalOpen]="modalOpen"
                [selectedInfoFields]="selectedInfoFields"
                (selectHandler)="selectInfoField($event)">
        </ycn-info-field-list>
    </div>
    <div class="modal-footer"></div>
</ycn-modal-base>

<ycn-feature-needed></ycn-feature-needed>
